var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"navs-wrapper"},_vm._l((_vm.navs),function(item){return _c('div',{key:item.id,staticClass:"nav-item",style:(`background-image: url(${_vm.baseUrl}${item.imgurl})`),on:{"click":function($event){return _vm.$router.push(item.href)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }